import React, { useEffect, useState } from "react";

import ReactPlayer from "react-player";
import { useParallax } from "react-scroll-parallax";

const StandardItem = ({ obj, id }) => {
  return (
    <>
      <div
        className={obj.colClass_second}
        data-aos="fade-up"
        data-aos-delay={`${(id + 1) * 300}`}
      >
        <div className="position-relative index_1 hero_text overflow-hidden">
          <ReactPlayer
            className="react-player"
            url={obj.videoUrl}
            width="100%"
            height="100%"
            min-height="100%"
            playing={true}
            loop={true}
            muted={true}
          />
          <p className="ff_josfin position-absolute bottom-0 start-0  d-none text-uppercase text-white font-md mb-0 ps-3 font-medium pt-4 pb-4">
            {obj.para1}
          </p>
          <div className="postioning_text position-absolute text-center px-3 ">
            <p className="ff_josfin text-uppercase text-white font-md mb-0 ps-3 font-medium ">
              {obj.para2}
            </p>
            <p className="ff_lato text-uppercase text-white font-sm opacity_8 mb-0  font-normal pt-2 ">
              {obj.para3}
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default StandardItem;
